import type {
  AutoSizeValue,
  PlainSizeValue
} from '@elfsight/configurator-contracts';

export function getAutoOrCustomSize(value?: AutoSizeValue | PlainSizeValue) {
  if (typeof value === 'string' || typeof value === 'number') {
    return value;
  }

  return value?.auto ? undefined : value?.customValue;
}
